// extracted by mini-css-extract-plugin
export default {"container":"BaseInsightsPage_container__Yyqiq","flexContainer":"BaseInsightsPage_flexContainer__g8ZpP","formItem":"BaseInsightsPage_formItem__KNmvV"};